import * as React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import Hamburger from "@material-ui/icons/Menu";
import LightModeIcon from "@material-ui/icons/Brightness7";
import DarkModeIcon from "@material-ui/icons/Brightness4";
import Login from "@material-ui/icons/ExitToApp";

const AnimatedNavbar = (props) => {
  const [navItemsClass, setNavItemsClass] = React.useState("inactive");
  const toggle = () => {
    /* We add the opening and closing classes only when we need to see the toggle animations,
    otherwise it will always be inactive */
    navItemsClass === "inactive"
      ? setNavItemsClass("opening")
      : setNavItemsClass("closing");
  };
  const closeNavbar = () => {
    setNavItemsClass("closing");
  };
  const onAnimationEnd = () => {
    // reverting back to active/inactive classes once opening/closing animations are done
    if (navItemsClass === "closing") setNavItemsClass("inactive");
    if (navItemsClass === "opening") setNavItemsClass("active");
  };
  return (
    <nav className="navbar-custom">
      <NavLink to="/home">
        <img
          src="/abrar_logo_2021.webp"
          className="brand"
          alt="abrarhayat_logo"
          onClick={closeNavbar}
        />
      </NavLink>
      <button
        className="toggler btn"
        onClick={toggle}
        name="nav-toggler"
        aria-label="Nav Toggler"
      >
        <Hamburger />
      </button>
      <ul
        className={`navbar-items ${navItemsClass}`}
        onAnimationEnd={onAnimationEnd}
      >
        <NavigationItem
          title="Home"
          linkPath="home"
          to="/home"
          closeNavbar={closeNavbar}
        />
        <NavigationItem
          title="About Us"
          linkPath="aboutus"
          to="/aboutus"
          closeNavbar={closeNavbar}
        />
        <NavigationItem
          title="Menu"
          linkPath="menu"
          to="/menu"
          closeNavbar={closeNavbar}
        />
        <NavigationItem
          title="Contact Us"
          linkPath="contactus"
          to="/contactus"
          closeNavbar={closeNavbar}
        />
        <button className="btn align-middle" onClick={props.toggleModal}>
          <Login color="action" className="align-middle" /> Login
        </button>
        <li>
          <button
            className="btn"
            onClick={props.handleThemeChange}
            name="theme-toggler"
            aria-label="Theme Toggler"
          >
            <div className="theme-toggler">
              {props.theme === "dark" ? (
                <LightModeIcon />
              ) : (
                <DarkModeIcon />
              )}
            </div>
          </button>
        </li>
      </ul>
    </nav>
  );
};
const NavigationItem = (props) => {
  return (
    <li>
      <NavLink to={props.to} onClick={props.closeNavbar}>
        {props.title}
      </NavLink>
    </li>
  );
};

NavigationItem.propTypes = {
  title: PropTypes.string,
  currentPath: PropTypes.string,
  NavLinkPath: PropTypes.string,
  to: PropTypes.string,
};

export default AnimatedNavbar;
